<nav class="fixed top-0 left-0 w-full z-50 bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100 transition-all duration-300">
    <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16 sm:h-20">

            <!-- Logo -->
            <div class="flex-shrink-0 flex items-center relative">
                <a routerLink="/" aria-label="Vettro Traders Home"
                    class="group relative inline-block transition-transform duration-300 hover:scale-105">
                    <div
                        class="absolute -inset-2 bg-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-[0_0_20px_rgba(212,175,55,0.4)]">
                    </div>
                    <img src="/content/Logos/Vettro-Traders_logo-01.svg" alt="Vettro Traders" fetchpriority="high"
                        loading="eager"
                        class="h-10 sm:h-12 w-auto max-w-[160px] sm:max-w-none object-contain relative z-10 filter drop-shadow-sm group-hover:drop-shadow-md transition-all duration-300">
                </a>
            </div>

            <!-- Desktop Links -->
            <div class="hidden lg:flex items-center gap-1">
                @for (link of links; track link.name) {
                <a [routerLink]="link.path"
                    routerLinkActive="!text-[#D4AF37] !border-b-2 !border-[#D4AF37]"
                    [routerLinkActiveOptions]="{exact: link.path === '/'}"
                    class="relative px-3 xl:px-4 py-2 text-sm font-semibold text-gray-600 hover:text-[#D4AF37] transition-all duration-200 tracking-wide border-b-2 border-transparent whitespace-nowrap">
                    {{ link.name }}
                </a>
                }
                <!-- CTA Quote Button -->
                <a routerLink="/contact"
                    class="ml-3 px-5 py-2.5 bg-[#D4AF37] text-black text-sm font-bold rounded-full hover:bg-[#B8860B] hover:shadow-lg hover:shadow-[#D4AF37]/30 transition-all duration-300 whitespace-nowrap tracking-wide">
                    Get Quote
                </a>
            </div>

            <!-- Mobile: Quote CTA + Hamburger -->
            <div class="lg:hidden flex items-center gap-2">
                <a routerLink="/contact"
                    class="px-3.5 py-1.5 bg-[#D4AF37] text-black text-xs font-bold rounded-full hover:bg-[#B8860B] transition-colors duration-200 tracking-wide">
                    Quote
                </a>
                <button (click)="toggleMenu()"
                    aria-label="Toggle navigation menu"
                    class="text-gray-700 hover:text-[#D4AF37] focus:outline-none p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                    <span class="material-icons text-2xl">{{ isMenuOpen() ? 'close' : 'menu' }}</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Mobile Drawer -->
    @if (isMenuOpen()) {
    <div class="lg:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-gray-100"
        style="animation: slideDown 0.2s ease-out both;">
        <div class="px-4 py-4 space-y-1">
            @for (link of links; track link.name) {
            <a [routerLink]="link.path" (click)="closeMenu()"
                routerLinkActive="bg-amber-50 text-[#D4AF37] border-l-4 border-[#D4AF37] font-bold"
                [routerLinkActiveOptions]="{exact: link.path === '/'}"
                class="flex items-center gap-3 px-4 py-3.5 rounded-xl text-sm font-medium text-gray-700 hover:text-[#D4AF37] hover:bg-amber-50 transition-all duration-200 border-l-4 border-transparent">
                @if (link.icon) {
                  <span class="material-icons text-lg opacity-70">{{ link.icon }}</span>
                }
                <span class="tracking-wide uppercase text-xs font-bold">{{ link.name }}</span>
                @if (link.badge) {
                  <span class="ml-auto text-[10px] bg-[#D4AF37] text-black px-2 py-0.5 rounded-full font-bold">{{ link.badge }}</span>
                }
            </a>
            }
            <div class="pt-2 border-t border-gray-100 mt-2">
                <div class="grid grid-cols-2 gap-2 text-center text-xs text-gray-400 pb-1">
                    <div class="flex items-center justify-center gap-1">
                        <span class="material-icons text-xs text-[#D4AF37]">verified</span>
                        ISO Verified
                    </div>
                    <div class="flex items-center justify-center gap-1">
                        <span class="material-icons text-xs text-[#D4AF37]">storefront</span>
                        5+ Centers
                    </div>
                </div>
            </div>
        </div>
    </div>
    }

</nav>

<style>
@keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
}
</style>